import {
  GET_USER_EMAIL,
  GET_USER_COMPANY_INFO,
  GET_USER_PERSONAL_INFO,
  DUPLICATE_EMAIL_FAIL,
  DUPLICATE_EMAIL_REQUEST,
  DUPLICATE_EMAIL_SUCCESS,
  SEND_DATA_FAIL,
  SEND_DATA_REQUEST,
  SEND_DATA_SUCCESS,
  GET_IPDATA_FAIL,
  GET_IPDATA_REQUEST,
  GET_IPDATA_SUCCESS,
  GET_PAGE_NAME,
  GET_PAGE_NAME_FAIL,
  SEND_TWILIO_REQ,
  SEND_TWILIO_SUCCESS,
  SEND_TWILIO_FAIL,
  FREETRIAL_CREATE_REQ,
  FREETRIAL_CREATE_SUCCESS,
  FREETRIAL_CREATE_FAIL,
  REDIRECT_STATUS_CHECKED,
  SUB_TO_PRODUCT_LIST_REQ,
  SUB_TO_PRODUCT_LIST_SUCCESS,
  SUB_TO_PRODUCT_LIST_FAIL,
  SEND_NOTIFICATION_UK_REQ,
  SEND_NOTIFICATION_UK_SUCCESS,
  SEND_NOTIFICATION_UK_FAIL,
  SEND_CHILI_REQ,
  SEND_CHILI_SUCCESS,
  SEND_CHILI_FAIL,
} from "../constants";

export const userDetailsReducer = (state = { user: {} }, action) => {
  switch (action.type) {
    case GET_USER_EMAIL:
      return {
        ...state,
        user: {
          email: action.payload,
          firstName: state.user.firstName,
          lastName: state.user.lastName,
        },
      };
    case GET_USER_COMPANY_INFO:
      return {
        ...state,
        user: {
          email: state.user.email,
          companyName: action.companyName,
          employeeRange: action.employeeRange,
          firstName: state.user.firstName,
          lastName: state.user.lastName,
        },
      };
    case GET_USER_PERSONAL_INFO:
      return {
        user: {
          email: state.user.email,
          companyName: state.user.companyName,
          employeeRange: state.user.employeeRange,
          firstName: action.firstName,
          lastName: action.lastName,
          phone: action.phone,
        },
      };
    default:
      return state;
  }
};

export const duplicateEmailReducer = (state = {}, action) => {
  switch (action.type) {
    case DUPLICATE_EMAIL_REQUEST:
      return { loading: true };
    case DUPLICATE_EMAIL_SUCCESS:
      return { loading: false, success: true };
    case DUPLICATE_EMAIL_FAIL:
      return { loading: false, success: false, error: action.payload };
    default:
      return state;
  }
};

export const sendDataReducer = (state = {}, action) => {
  switch (action.type) {
    case SEND_DATA_REQUEST:
      return { loading: true };
    case SEND_DATA_SUCCESS:
      return { loading: false, success: true };
    case SEND_DATA_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};

export const getIpDataReducer = (state = {}, action) => {
  switch (action.type) {
    case GET_IPDATA_REQUEST:
      return { loading: true };
    case GET_IPDATA_SUCCESS:
      return { loading: false, success: true, ipInfo: action.payload };
    case GET_IPDATA_FAIL:
      return {
        loading: false,
        ipInfo: action.payload,
        error: action.payloadError,
      };
    default:
      return state;
  }
};

export const getPageNameReducer = (state = {}, action) => {
  switch (action.type) {
    case GET_PAGE_NAME:
      return { pageURL: action.payload };
    case GET_PAGE_NAME_FAIL:
      return { pageURL: action.payload };
    default:
      return state;
  }
};

export const sendTwilioSMSReducer = (state = {}, action) => {
  switch (action.type) {
    case SEND_TWILIO_REQ:
      return { loading: true };
    case SEND_TWILIO_SUCCESS:
      return { loading: false, success: true };
    case SEND_TWILIO_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};

export const freeTrialAccountReducer = (state = {}, action) => {
  switch (action.type) {
    case FREETRIAL_CREATE_REQ:
      return { loadingFT: true };
    case FREETRIAL_CREATE_SUCCESS:
      return { loadingFT: false, successFT: true, magicLink: action.payload };
    case FREETRIAL_CREATE_FAIL:
      return { loadingFT: false, errorFT: action.payload };
    default:
      return state;
  }
};

export const redirectStatusReducer = (state = {}, action) => {
  switch (action.type) {
    case REDIRECT_STATUS_CHECKED:
      return { status: true };
    default:
      return state;
  }
};

export const addToProductListReducer = (state = {}, action) => {
  switch (action.type) {
    case SUB_TO_PRODUCT_LIST_REQ:
      return { loadingPL: true };
    case SUB_TO_PRODUCT_LIST_SUCCESS:
      return { loadingPL: false, successPL: true };
    case SUB_TO_PRODUCT_LIST_FAIL:
      return { loadingPL: false, errorPL: action.payload };
    default:
      return state;
  }
};

export const sendNotificationToUKReducer = (state = {}, action) => {
  switch (action.type) {
    case SEND_NOTIFICATION_UK_REQ:
      return { loading: true };
    case SEND_NOTIFICATION_UK_SUCCESS:
      return { loading: false, success: true };
    case SEND_NOTIFICATION_UK_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};

export const chilipiperdemoReducer = (state = {}, action) => {
  switch (action.type) {
    case SEND_CHILI_REQ:
      return { loading: true };
    case SEND_CHILI_SUCCESS:
      return { loading: false, success: true, chiliData: action.payload };
    case SEND_CHILI_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};
